import { all, takeEvery,call, put, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import jwt from "jsonwebtoken";

import { getToken, clearToken } from '@iso/lib/helpers/utility';
import JwtAuthentication from '@iso/lib/helpers/jwtAuthentication';
import { setCookie, removeCookie ,getCookie} from '@iso/lib/helpers/session';
import actions from './actions';

const fakeApiCall = true; // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function*({ payload }) {
    const { token } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
        profile: 'Profile',
      });
    } else {
      if (fakeApiCall) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: 'secret token',
          profile: 'Profile',
        });
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    }
  });
}


export function* jwtLoginRequest() {
   yield takeEvery(actions.JWT_LOGIN_REQUEST, function*({ payload }) {
     const result = yield call(JwtAuthentication.login, payload.userInfo);
    //return;
    if (result.status===0) {
      notification('error', result.message);
      yield put({ type: actions.LOGIN_ERROR });
    } else {
      if(result.success){
        let tokenObj=jwt.decode(result.data.token, {
          complete: true
         });
         let userData=tokenObj?tokenObj.payload.language:null;
        // console.log('result',result );
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: result.data.token,
        name: result.data.name,
        role: result.data.role, 
        id:result.data.id,
        userName:result.data.userName,
        language : userData ? userData: null ,
        // itsMeDiffData:{new:{firstName:'Raj', lastName:'Singh'},old:{firstName:'lucky', lastName:'singh'}},

      });
      if(result.data.role == 'client'){
        window.location.href='/investor-dashboard';
       }else if(result.data.role == 'cddUser'){
       window.location.href = '/dashboard/cdd-dashboard';
       }else{
        window.location.href = '/dashboard';
       }
     }else{
         notification('error', result.message);
        setTimeout(() => {
                  window.location.reload();
        },1000);
         
    }
    }
  });
}


// export function* itsmeLoginRequest() {
//   yield takeEvery(actions.ITSME_LOGIN_REQUEST, function*({ payload }) {
//     const result = yield call(JwtAuthentication.itsme, payload.userInfo);
//    //return;
//    if (result.status===0) {
//      notification('error', result.message);
//      yield put({ type: actions.LOGIN_ERROR });
//    } else {
//      if(result.success){
//       let tokenObj=jwt.decode(result.data.token, {
//         complete: true
//        });
//        let userData=tokenObj && tokenObj.payload && tokenObj.payload.language ? tokenObj.payload.language:null;
//       console.log('result',result );
//      yield put({
//        type: actions.LOGIN_SUCCESS,
//        token: result.data.token,
//        name: result.data.name,
//        role: result.data.role, 
//        id:result.data.id,
//        itsMeDiffData:result.data.itsMeDiffData?result.data.itsMeDiffData:null,
//        language : userData ? userData: null ,

//      });
//      if(result.data.role == 'client'){
//        window.location.href='/investor-dashboard';
//       }else if(result.data.role == 'cddUser'){
//       window.location.href = '/dashboard/cdd-dashboard';
//       }else{
//        window.location.href = '/dashboard';
//       }
//     }else{
//         notification('error', result.message);
//        setTimeout(() => {
//         // window.location.href = '/login';
//       },1000);
        
//    }
//    }
//  });
// }
export function* itsmeLoginRequest() {
  yield takeEvery(actions.ITSME_LOGIN_REQUEST, function*({ payload }) {
    const result = yield call(JwtAuthentication.itsme, payload.userInfo);
   //return;
   if (result.status===0) {
     notification('error', result.message);
     yield put({ type: actions.LOGIN_ERROR });
   } else if(result.success){
      if( result.data && result.data.multiUser!=null ){
        window.location.href='/multiUser';
        // setCookie('multiUser', JSON.stringify(result.data.multiUser))
        localStorage.setItem('multiUser', JSON.stringify(result.data.multiUser))
      }
      else{
        let tokenObj=jwt.decode(result.data.token, {
          complete: true
        });
        let userData=tokenObj && tokenObj.payload && tokenObj.payload.language ? tokenObj.payload.language:null;
        // console.log('result',result );
        yield put({
        type: actions.LOGIN_SUCCESS,
        token: result.data.token ? result.data.token :'',
        name: result.data.name ? result.data.name :'',
        role: result.data.role ? result.data.role :'', 
        id: result.data.id ? result.data.id : null,
        itsMeDiffData:result.data.itsMeDiffData?result.data.itsMeDiffData:null,
        language : userData ? userData: null ,

        });
       if(result.data.role == 'client'){
        window.location.href='/investor-dashboard';
        }
      else if(result.data.role == 'cddUser'){
      window.location.href = '/dashboard/cdd-dashboard';
      }else{
       window.location.href = '/dashboard';
      }
    }
    }else{
        notification('error', result.message);
       setTimeout(() => {
        // window.location.href = '/login';
      },1000);
        
    }

  });
}

export function* firstLoginRequest() {
  yield takeEvery(actions.FIRST_LOGIN_REQUEST, function*({ payload }) {
     const result = yield call(JwtAuthentication.firstLogin, payload.userInfo);
   //return;
   if (result.status===0) {
     notification('error', result.message);
     yield put({ type: actions.LOGIN_ERROR });
   } else {
     if(result.success){
     yield put({
       type: actions.LOGIN_SUCCESS,
       token: result.data.token,
       name: result.data.name,
       role: result.data.role, 
       id:result.data.id,
       userName:result.data.userName

     });
     if(result.data.role == 'client'){
       window.location.href='/investor-dashboard';
      }else{
      window.location.href = '/dashboard';
      }
    }else{
        notification('error', result.message);
        yield put({
          type: actions.FIRST_LOGIN_ERROR,
          result: payload.hit+1,
        });
        
   }
   }
 });
}


export function* ssoLoginRequest() {
  yield takeEvery(actions.SSO_LOGIN_REQUEST, function*({ payload }) {    
      let tokenObj=jwt.decode(payload.userInfo, {
      complete: true
     });
       let userData=tokenObj?tokenObj.payload:null;
     if(userData){
     yield put({
       type: actions.LOGIN_SUCCESS,
       token: payload.userInfo,
       name: userData.name,
       role: userData.role, 
       id:userData.id,
       userName:userData.userName
     });
     if(userData.role == 'client'){
       window.location.href='/investor-dashboard';
      }else{
      window.location.href = '/dashboard';
      }
    }else{
        notification('error', userData.message);
       setTimeout(() => {
                 window.location.reload();
       },1000);
        
   }
   
 });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    var language="";
    if(payload.language =="fr"){
      language = "french"
    }
    else if(payload.language =="nl"){
      language = "dutch"
    }
    else{
      language = "english"
    }

       yield localStorage.setItem('id_token', payload.token);
       if(payload.multiUser){
        setCookie("multiUser", JSON.stringify(payload.multiUser)); //NEW
  }
  else{
    // setCookie('login_saga', payload.token);
    setCookie("name", payload.name); //NEW
    setCookie("role", payload.role); //NEW
    setCookie("id", payload.id); //NEW
    setCookie("userName",payload.userName)
    if(payload.role == 'client'){
      setCookie("language",language)
    }
    if(payload.itsMeDiffData){
       setCookie("itsMeDiffData", JSON.stringify(payload.itsMeDiffData)); //NEW
    }
    yield setCookie('id_token', payload.token);
  }
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
    var role=getCookie('role');
    removeCookie('id_token');
    removeCookie('role');
    removeCookie("id");  //NEW
    removeCookie("name"); //NEW
    removeCookie("itsMeDiffData"); //NEW
    removeCookie("userName")
    removeCookie("language")
    removeCookie("multiUser")
    localStorage.removeItem('multiUser');
    yield clearToken();
    if(role=='client'){
   // history.push('/');
  //  window.location.href = '/';
      window.history.pushState(null, '', window.location.href = '/');
      window.history.back();
      window.history.forward();
      window.onpopstate = function() {
      window.history.go(1);
    };
  }else if(role == undefined){
    // console.log("undefined")
  }else{
    window.location.href = '/admin-signin';
  }
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: 'Profile',
      });
    }
  });
}


export default function* rootSaga() {
  yield all([
  //  fork(checkAuthorization),
    fork(loginRequest),
    fork(jwtLoginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
    fork(ssoLoginRequest),
    fork(firstLoginRequest),
    fork(itsmeLoginRequest)
  ]);
}
